<template>
    <Main>
        <box-loading v-if="isLoading"></box-loading>
        <div v-if="recordShare && !isLoading && listFields" class="data-view-layout">
            <el-row :gutter="20" v-for="(row, rIndex) in displayedRows" :key="'row-' + rIndex" class="mb-3" type="flex" style="flex-wrap: wrap;">
                <el-col v-for="item in row.fields" :span="item.layoutWidth" :xs="24" :key="item.code">
                    <InputField v-if="item.type !== TYPE_TEXTS && item.type !== TYPE_SUB_TABLE" type="vertical" :span-input="18" :span-label="6" :label-text="item.label" classes="mb-1 mb-sm-4" :is-required="item.required">
                        <input-kintone-setting
                            :readonly="isPageDetail"
                            :disabled="isInputDisabled(item.code)"
                            :type-input="item.type"
                            v-model="recordShare[item.code]"
                            :options="item.options"
                            :lookup="item.lookup"
                            @onValidate="onValidate(item.code)"
                            :data-local="dataMaster"
                            :formatCalc="item.format"
                            :protocol-link="item.protocol"
                            :unit="item.unit"
                        ></input-kintone-setting>
                        <template #error v-if="errorInfo[item.code]"> {{ errorInfo[item.code] }}</template>
                    </InputField>

                    <InputField v-else type="vertical" :span-input="24" :span-label="24" classes="mb-3" :label-text="item.label">
                        <textarea class="form-control" :rows="3" :readonly="isInputDisabled(item.code)" v-if="item.type === TYPE_TEXTS" v-model="recordShare[item.code]"></textarea>
                        <div v-if="item.type === TYPE_SUB_TABLE" class="table-sm table-kb">
                            <table class="table table-hover table-common">
                                <thead>
                                    <tr class="row-preview row-preview__header">
                                        <th scope="col" v-for="field in item.fields" :key="field.code">{{ field.label }}</th>
                                        <th v-if="!isPageDetail"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(rowSub, indexR) in recordShare[item.code]" :key="indexR" class="row-preview row-preview--top row-preview__content">
                                        <td
                                            v-for="(fieldSub, indexSub) in rowSub.value"
                                            :key="indexSub"
                                            :data-title="item.fields[getField(rowSub.value, indexSub)] && item.fields[getField(rowSub.value, indexSub)].label"
                                        >
                                            <input-kintone-setting
                                                :disabled="isPageDetail"
                                                :type-input="fieldSub.type"
                                                v-model="fieldSub.value"
                                                :options="fieldSub.options"
                                                :lookup="fieldSub.lookup"
                                                :formatCalc="fieldSub.format"
                                                v-if="fieldSub.type !== TYPE_TEXTS"
                                                :data-local="dataMaster"
                                                :protocol-link="item.protocol"
                                                :unit="item.unit"
                                            >
                                            </input-kintone-setting>
                                            <textarea :readonly="isPageDetail" v-model="fieldSub.value" v-if="fieldSub.type === TYPE_TEXTS" :rows="3" class="form-control"></textarea>
                                        </td>
                                        <td class="col-sub-table" v-if="!isPageDetail">
                                            <i @click="onDeleteRowSubTable(item.code, indexR)" :class="{ disabled: recordShare[item.code].length < 2 }" class="el-icon-remove icon-remove mx-2"></i>
                                            <i @click="onAddRowSubTable(item, indexR)" class="el-icon-circle-plus icon-plus mx-2"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <template #error v-if="errorInfo[item.code]">
                            {{ errorInfo[item.code] }}
                        </template>
                    </InputField>
                </el-col>
            </el-row>
        </div>
        <template #bottomAction>
            <div class="text-right">
                <Button type="warning" @click="handleCancel">{{ $t('button.cancel') }}</Button>
                <Button type="primary" classes="ml-3" v-if="!isPageDetail" @click="handleSubmitData">{{ $t('button.saveNew') }}</Button>
            </div>
        </template>
    </Main>
</template>

<script>
import {
    TYPE_TEXT,
    TYPE_CALC,
    TYPE_RECORD_NUMBER,
    TYPE_DATE,
    TYPE_DROPDOWN,
    TYPE_TIME,
    TYPE_NUMBER,
    TYPE_TEXTS,
    TYPE_SUB_TABLE,
    TYPE_FILE,
    TYPE_RADIO_BUTTON,
    TYPE_DATE_TIME,
    TYPE_CHECK_BOX,
    TYPE_MULTI_SELECT,
    TYPE_LINK,
    TYPE_ORGANIZATION_SELECT
} from '@/config/constants';
import Main from '@/components/partials/layout/Main';
import InputField from '@/components/partials/InputField';
import Button from '@/components/partials/Button';
import BoxLoading from '@/components/partials/BoxLoading';
import { formatDateTime, formatDateTimeZoneWithHour, validEmail } from '@/utils';
import { mapDataRecord, mapDataField } from './index';
import InputKintoneSetting from '@/components/partials/InputKintonSetting';
import isUrl from 'is-url';
import { mapState } from 'vuex';

export default {
    components: {
        InputKintoneSetting,
        BoxLoading,
        InputField,
        Main,
        Button
    },
    data() {
        return {
            TYPE_TEXT,
            TYPE_LINK,
            TYPE_RECORD_NUMBER,
            TYPE_DATE,
            TYPE_DROPDOWN,
            TYPE_TIME,
            TYPE_NUMBER,
            TYPE_TEXTS,
            TYPE_SUB_TABLE,
            TYPE_FILE,
            TYPE_RADIO_BUTTON,
            TYPE_CALC,
            TYPE_DATE_TIME,
            TYPE_CHECK_BOX,
            isEdit: false,
            arrayFieldDisabled: [],
            fieldDisplayLayout: [],
            roleUser: ['detail', '', '', ''],
            recordShare: null,
            listFields: [],
            listFieldsKeys: [],
            isPageDetail: false,
            isLoading: false,
            errorInfo: {},
            dataMaster: {
                users: [],
                groups: [],
                departments: []
            }
        };
    },
    computed: {
      ...mapState('auth', ['userInfo']),
      isAccountAdmin() {
        if (localStorage.getItem('KB_DEV_CUSTOMER') || this.userInfo) {
          let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || this.userInfo;
          if (user) {
            let roleUser = parseInt(user.type);
            return roleUser === 2;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      displayedRows() {
         if (!this.listFields || this.listFields.length === 0) return [];

         let hasLayout = this.fieldDisplayLayout &&
                         Array.isArray(this.fieldDisplayLayout) &&
                         this.fieldDisplayLayout.some(item => 'isHidden' in item || 'row' in item);

         let rows = [];

         if (!hasLayout) {
             // Cấu trúc cũ trước đây
             let hiddenCodes = this.fieldDisplayLayout ? this.fieldDisplayLayout.map(h => typeof h === 'object' ? h.code : h) : [];
             let visibleFields = [];
             let unassignedFields = [];

             this.listFields.forEach(field => {
                 let isHidden = hiddenCodes.includes(field.code);
                 if (isHidden) {
                     if (this.isAccountAdmin) unassignedFields.push(field);
                 } else {
                     visibleFields.push(field);
                 }
             });

             let mapField = field => {
                 let isFullWidth = field.type === 'SUBTABLE';
                 return { ...field, layoutWidth: isFullWidth ? 24 : 12 };
             };
             rows = [{ fields: visibleFields.map(mapField) }];
             if (unassignedFields.length > 0) {
                 rows.push({ fields: unassignedFields.map(mapField) });
             }
             return rows;
         }

         // Cấu trúc layout mới (có Kéo Thả dòng)
         let rowMap = {};
         let unassignedFields = [];

         this.fieldDisplayLayout.forEach((layoutInfo, layoutIndex) => {
             let field = this.listFields.find(f => f.code === layoutInfo.code);
             if (!field) return;

             let isHidden = layoutInfo.isHidden;
             let layoutWidth = layoutInfo.width ? layoutInfo.width : 8;
             if (field.type === 'SUBTABLE') layoutWidth = 24;

             if (isHidden) {
                 if (this.isAccountAdmin) {
                     unassignedFields.push({ ...field, layoutWidth: 12, layoutOrder: layoutInfo.order !== undefined ? layoutInfo.order : layoutIndex });
                 }
                 return;
             }

             if (layoutInfo.row !== null && layoutInfo.row !== undefined) {
                 if (!rowMap[layoutInfo.row]) rowMap[layoutInfo.row] = [];
                 rowMap[layoutInfo.row].push({
                     ...field,
                     layoutWidth: layoutWidth,
                     layoutOrder: layoutInfo.order !== undefined ? layoutInfo.order : layoutIndex
                 });
             } else {
                 unassignedFields.push({ ...field, layoutWidth: 12, layoutOrder: layoutInfo.order !== undefined ? layoutInfo.order : layoutIndex });
             }
         });

         this.listFields.forEach((field, index) => {
             let hasLayout = this.fieldDisplayLayout.find(l => l.code === field.code);
             if (!hasLayout) {
                 unassignedFields.push({ ...field, layoutWidth: 12, layoutOrder: 99999 + index });
             }
         });

         rows = Object.keys(rowMap).sort((a,b) => Number(a) - Number(b)).map(rIndex => {
             let sortedFields = rowMap[rIndex].sort((a, b) => a.layoutOrder - b.layoutOrder);
             return { fields: sortedFields };
         });

         if (unassignedFields.length > 0) {
             let sortedUnassigned = unassignedFields.sort((a, b) => a.layoutOrder - b.layoutOrder);
             rows.push({ fields: sortedUnassigned });
         }

         return rows;
      }
    },
    mounted() {
        let idShare = this.$route.query.idShare;
        let idRecord = this.$route.query.idRecord;
        let currentPath = this.$router.currentRoute.path;
        if (currentPath === '/share/data-view/detail' || currentPath === '/share-user-children/data-view/detail') {
            this.isPageDetail = true;
        }
        if (idShare && idRecord) {
            this.handleGetDetailDataShare();
            this.onGetDataRecord(idShare, idRecord);
            this.handleGetListGroupUser(idShare);
        }
    },
    methods: {
        isInputDisabled(itemCodeField) {
            if (this.isPageDetail) return true;
            if (!this.arrayFieldDisabled || this.arrayFieldDisabled?.length === 0) return false;
            let findIndex = this.arrayFieldDisabled.findIndex((item) => item.code === itemCodeField);
            return findIndex > -1 && !this.isAccountAdmin;
        },

        isInputHidden(itemCodeField) {
          if (!this.fieldDisplayLayout || this.fieldDisplayLayout?.length === 0) return false;
          let hasLayout = this.fieldDisplayLayout && Array.isArray(this.fieldDisplayLayout) && this.fieldDisplayLayout.some(item => 'isHidden' in item || 'row' in item);

          if (hasLayout) {
              let fieldLayout = this.fieldDisplayLayout.find((item) => item.code === itemCodeField);
              if (fieldLayout) {
                  return fieldLayout.isHidden && !this.isAccountAdmin;
              }
              return !this.isAccountAdmin;
          }

          let hiddenCodes = this.fieldDisplayLayout.map(h => typeof h === 'object' ? h.code : h);
          return hiddenCodes.includes(itemCodeField) && !this.isAccountAdmin;
        },

        getField(objField, index) {
            let arrFields = Object.keys(objField) || [];
            let indexField = arrFields.findIndex((elm) => elm === index);
            return Math.max(indexField, 0);
        },

        handleGetListGroupUser(idShare) {
            let successCallback = (response) => {
                if (response.status === 200) {
                    let { data } = response.data.data;
                    this.dataMaster.users = [].concat(
                        data.user.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.departments = [].concat(
                        data.department.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster.groups = [].concat(
                        data.group.map((elm) => {
                            return elm.name;
                        })
                    );
                    this.dataMaster = Object.assign({}, this.dataMaster);
                }
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback,
                shareId: idShare
            };

            this.$store.dispatch('share/getAllGroupUser', payload);
        },
        onGetDataRecord(queryId, idRecord) {
            this.isLoading = true;
            let successCallback = (response) => {
                this.isEdit = true;
                let { data } = response.data.data;
                this.recordShare = mapDataRecord(data.records.records);
                this.listFields = mapDataField(data.fields, this.recordShare);
                this.listFields.forEach((item) => {
                    const { code } = item || {};
                    if (code) {
                        this.errorInfo[code] = '';
                    }
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                shareId: queryId,
                recordId: idRecord
            };
            this.$store.dispatch('share/getDetailDataShare', payload);
        },
        handleGetDetailDataShare() {
            this.isLoading = true;
            let successCallback = (response) => {
                let dataShare = response.data?.data?.data;
                this.arrayFieldDisabled = dataShare?.array_field_disabled;
                this.fieldDisplayLayout = dataShare?.array_field_detail_hidden;
                this.roleUser = dataShare?.list_role
                    ?.filter((elm) => elm.enable)
                    .map((elm) => {
                        return elm.type;
                    });
                this.isLoading = false;
            };

            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: this.$route.query.idShare
            };
            this.$store.dispatch('connect/getDetailConnect', payload);
        },
        getQueryString() {
            return 'last_id=0&limit=10';
        },
        handleCancel() {
            let queryId = this.$route.query.idShare ?? '';
            let dataLinkId = this.$route.query.idDataLink ?? '';
            let currentPath = this.$router.currentRoute.path;
            let pathMapping = {
                '/share/data-view/detail': '/share/data-view',
                '/share/data-view/edit': '/share/data-view',
                '/data-link-multi/data-view/detail': '/data-link-multi/data-view',
                '/data-link-multi/data-view/edit': '/data-link-multi/data-view',
                '/share-user-children/data-view/detail': '/share-user-children/data-view',
                '/share-user-children/data-view/edit': '/share-user-children/data-view'
            };
            let pathCancel = pathMapping[currentPath] || '/share/data-view';
            let query = {
                id: queryId,
                idDataLink: dataLinkId,
                link_name: this.$route.query.link_name || ''
            };
            if (this.$route.query.page) query.page = this.$route.query.page;
            if (this.$route.query.limit) query.limit = this.$route.query.limit;
            if (this.$route.query.numberOrder) query.numberOrder = this.$route.query.numberOrder;
            this.$router.push({
                path: pathCancel,
                query: query
            });
        },
        onDeleteRowSubTable(key, indexRow) {
            if (this.recordShare[key] && this.recordShare[key].length > 1) {
                this.recordShare[key].splice(indexRow, 1);
            }
        },
        onAddRowSubTable(itemField, rowIndex) {
            let obj = {
                id: '',
                value: {}
            };
            const itemFieldGet = Object.assign({}, itemField);

            if (itemFieldGet && itemFieldGet.fields.length > 0) {
                itemFieldGet.fields.map((elm) => {
                    obj.value[elm.code] = {
                        type: elm.type,
                        value: ''
                    };
                    if (elm.lookup) {
                        obj.value[elm.code].lookup = elm.lookup;
                    }
                    if (elm.options) {
                        if ([TYPE_DROPDOWN, TYPE_MULTI_SELECT].includes(elm.type)) {
                            obj.value[elm.code].options = Object.keys(elm.options);
                        } else {
                            obj.value[elm.code].options = [];
                            Object.keys(elm.options).map((key) => {
                                let objOption = {
                                    value: key,
                                    label: key
                                };
                                obj.value[elm.code].options.push(objOption);
                            });
                        }
                    }
                    if ([TYPE_ORGANIZATION_SELECT, TYPE_CHECK_BOX, TYPE_MULTI_SELECT].includes(elm.type)) {
                        obj.value[elm.code].value = [];
                    }
                });
            }
            this.recordShare[itemFieldGet.code].splice(rowIndex + 1, 0, Object.assign({}, obj));
            this.recordShare[itemFieldGet.code] = [].concat(this.recordShare[itemFieldGet.code]);
            this.recordShare = Object.assign({}, this.recordShare);
        },
        handleSubmitData() {
            let { isEdit } = this;
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                if (response.status === 200) {
                    let responseData = response.data.data.data;
                    let statusError = responseData.status || false;
                    if (statusError) {
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'success',
                            message: isEdit ? this.$t('recordForm.msgUpdateSuccessfully') : this.$t('recordForm.msgCreateSuccessfully')
                        });
                        this.handleCancel();
                    } else {
                        let messageError = responseData.error ? `[${responseData.error.code}] ${responseData.error.message}` : '';
                        this.$store.commit('noticeSystem/SET_MESSAGE', {
                            isShowMessage: true,
                            type: 'error',
                            message: messageError
                        });
                    }
                }
                this.isLoading = false;
            };

            let errorCallback = () => {
                this.isLoading = false;
            };
            let dataPayload = [];
            let objectRecord = {};
            Object.keys(this.recordShare).map((key) => {
                let typeField = '';
                let indexField = this.listFields.findIndex((elm) => elm.code === key);
                if (indexField >= 0 || key === '$id') {
                    if (key === '$id') {
                        objectRecord[key] = {
                            type: '__ID__',
                            value: this.recordShare[key]
                        };
                    } else {
                        typeField = this.listFields[indexField].type;
                        if (typeField !== TYPE_SUB_TABLE) {
                            if (typeField === TYPE_DATE_TIME) {
                                objectRecord[key] = {
                                    type: typeField,
                                    value: this.recordShare[key] ? formatDateTimeZoneWithHour('', this.recordShare[key]) : ''
                                };
                            } else if (typeField === TYPE_DATE) {
                                objectRecord[key] = {
                                    type: typeField,
                                    value: this.recordShare[key] ? formatDateTime(this.recordShare[key], 'YYYY-MM-DD') : ''
                                };
                            } else if ([TYPE_CHECK_BOX, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(typeField)) {
                                objectRecord[key] = {
                                    type: typeField,
                                    value: this.recordShare[key] ? this.recordShare[key].join(';') : ''
                                };
                            } else if (typeField === TYPE_CALC || typeField === TYPE_FILE) {
                                objectRecord[key] = {
                                    type: typeField,
                                    value: ''
                                };
                            } else {
                                objectRecord[key] = {
                                    type: typeField,
                                    value: this.recordShare[key]
                                };
                            }
                        } else {
                            if (this.recordShare[key]) {
                                let dataTable = [];

                                this.recordShare[key].map((elm) => {
                                    let obj = {
                                        id: elm.id,
                                        value: {}
                                    };
                                    let valueElm = elm.value;
                                    Object.keys(valueElm).map((keyField) => {
                                        obj.value[keyField] = {
                                            type: valueElm[keyField].type,
                                            value: valueElm[keyField].value
                                        };
                                        if ([TYPE_CHECK_BOX, TYPE_DROPDOWN, TYPE_MULTI_SELECT, TYPE_ORGANIZATION_SELECT].includes(valueElm[keyField].type)) {
                                            if (obj.value[keyField].value && Array.isArray(obj.value[keyField].value)) {
                                                obj.value[keyField].value = obj.value[keyField].value ? obj.value[keyField].value.join(';') : '';
                                            }
                                        } else if (valueElm[keyField].type === TYPE_DATE_TIME) {
                                            obj.value[keyField].value = obj.value[keyField].value ? formatDateTimeZoneWithHour('', obj.value[keyField].value) : '';
                                        } else if (valueElm[keyField].type === TYPE_DATE) {
                                            obj.value[keyField].value = obj.value[keyField].value ? formatDateTime(obj.value[keyField].value, 'YYYY-MM-DD') : '';
                                        } else if (valueElm[keyField].type === TYPE_CALC || valueElm[keyField].type === TYPE_FILE) {
                                            obj.value[keyField].value = '';
                                        }
                                    });
                                    dataTable.push(obj);
                                });

                                objectRecord[key] = {
                                    type: typeField,
                                    value: dataTable
                                };
                            }
                        }
                    }
                }
            });
            dataPayload.push(objectRecord);
            let payload = {
                successCallback,
                errorCallback,
                data: dataPayload,
                shareId: this.$route.query.idShare,
                recordId: this.$route.query.idRecord
            };
            let action = isEdit ? 'share/updateDataShare' : 'share/createDataShare';
            this.$store.dispatch(action, payload);
        },
        onValidate(field) {
            let check = true;
            let { recordShare } = this;
            if (recordShare) {
                let listDataRequired = this.listFields.filter(this.filterCondition);
                listDataRequired.map((elm) => {
                    this.errorInfo[elm.code] = '';
                    if (!field || field === elm.code) {
                        if (elm.type === TYPE_LINK) {
                            this.errorInfo[elm.code] = '';
                            if (recordShare[elm.code]) {
                                if (elm.protocol === 'WEB' && !isUrl(recordShare[elm.code])) {
                                    check = false;
                                    this.errorInfo[elm.code] = this.$t('msgCommon.msgLinkFormat', { field: elm.label });
                                }
                                if (elm.protocol === 'MAIL' && !validEmail(recordShare[elm.code])) {
                                    check = false;
                                    this.errorInfo[elm.code] = this.$t('pageLogin.errorMailFormat');
                                }
                                if (elm.protocol === 'CALL') {
                                }
                            }
                        } else if (!recordShare[elm.code] || (recordShare[elm.code] && Array.isArray(recordShare[elm.code]) && recordShare[elm.code].length === 0)) {
                            this.errorInfo[elm.code] = this.$t('msgCommon.msgRequired', { field: elm.label });
                            check = false;
                        }
                    }
                });
            }
            if (!field) {
            }
            this.errorInfo = Object.assign({}, this.errorInfo);
            return check;
        },
        filterCondition(item) {
            let result = false;
            if (item) {
                if (item.required) {
                    result = true;
                } else if (item.type === TYPE_LINK) {
                    result = true;
                } else {
                    result = false;
                }
            }
            return result;
        }
    }
};
</script>
